import apiClient from "../util/ApiClient";

export const logError = async function(jsonErrorObject) {
  let myError = jsonErrorObject;
  return apiClient.post("Error/LogError", {
    Error: myError
  });
};
